import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CtaSection = () => (
  <section className="py-16 sm:py-24 bg-card/30">
    <div className="container mx-auto px-5 sm:px-4">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="font-display text-2xl sm:text-4xl md:text-5xl font-bold mb-6">
          Vamos <span className="text-gradient-green">Descobrir</span> suas Personas?
        </h2>
        <p className="text-base sm:text-xl text-muted-foreground mb-8 sm:mb-10">Faça o Teste Express gratuito e comece sua jornada de transformação hoje mesmo.</p>
        <Link to="/teste" className="btn-elegant inline-flex w-full sm:w-auto items-center justify-center gap-2 text-base sm:text-lg px-6 sm:px-12 py-3.5 sm:py-4 animate-pulse-glow">
          Começar Agora
          <ArrowRight className="w-5 h-5 shrink-0" />
        </Link>
      </div>
    </div>
  </section>
);

export default CtaSection;
